var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('draggable',{staticClass:"draggable-card-list",attrs:{"draggable":".draggable-card"},on:{"update":function (e) { this$1.$emit('move', {fromIndex: e.oldIndex, toIndex: e.newIndex}) }}},[_vm._t("default")],2):_c('div',{staticClass:"draggable-card-list"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }